import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import { EditUserStatus } from "../actions/admin";
import { getAllPlans } from "../actions/currency";

const initialFormValue = {
  name: "",
  status: "",
  walletAddress: "",
  planName: "",
};

const EditUsersModal = ({ label, show, handleClose, record, getUserAllList }) => {
  // console.log('record----------', record)
  const [formValue, setFormValue] = useState(initialFormValue);
  const [errors, setErrors] = useState({});
  const [plans, setPlans] = useState([]);

  // Fetch user details & plans
  useEffect(() => {
    if (record) {
      
      setFormValue(record);
    }
    fetchPlans();
  }, [record]);

  // Fetch all plans for dropdown
  const fetchPlans = async () => {
    try {
      const { status, result } = await getAllPlans();
      if (status === "success" && result?.length) {
        const formattedPlans = result.map((plan) => ({
          ...plan,
          label: plan.planName,
          value: plan.planName,
        }));
        setPlans(formattedPlans);
      }
    } catch (err) {
      console.error("Error fetching plans:", err);
      toast.error("Failed to fetch plans.");
    }
  };

  // Validation logic
  const validate = (values) => {
    const error = {};
    if (isEmpty(values.name) && isEmpty(values.planName))
      error.name = "Name field is required";
    if (typeof values.status === "undefined")
      error.status = "Status is required";
    return error;
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formValue, [name]: value };
    setFormValue(updatedForm);
    setErrors(validate(updatedForm));
  };

  // Handle status dropdown
  const handleStatusChange = (selected) => {
    setFormValue((prev) => ({ ...prev, status: selected.value }));
  };

  // Handle modal close
  const handleCloseModal = () => {
    handleClose();
    setFormValue(initialFormValue);
    setErrors({});
  };

  // Submit logic
  const handleSubmit = async () => {
    const validationErrors = validate(formValue);
    setErrors(validationErrors);

    if (Object.values(validationErrors).some(Boolean)) return;

    const payload = {
      _id: record?._id,
      name: formValue?.name,
      status: formValue?.status,
      planName: formValue?.planName || "",
    };
   
    try {
      const { status, message } = await EditUserStatus(payload);

      if (status === "success") {
        toast.success(
          formValue?.status ? "User activated successfully" : "User inactivated successfully"
        );
        handleCloseModal();
        getUserAllList();
      } else {
        toast.error(message || "Failed to update user status.");
        handleCloseModal();
        getUserAllList();
      }
    } catch (err) {
      console.error("handleSubmit__err", err);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const statusOptions = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
  ];

  const customSelectStyles = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      backgroundColor: isHovered || isFocused || isSelected ? "#00ddeb" : "#000",
      color: isHovered || isFocused || isSelected ? "#000" : "#fff",
      fontSize: "13px",
      cursor: "pointer",
    }),
    control: (provided) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "43px",
      padding: "0px 10px",
      fontSize: "13px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      padding: 0,
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: "#fff",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      borderRadius: 5,
      background: "transparent",
    }),
  };

  return (
    <Modal
      centered
      className="cmn_modal"
      show={show}
      onHide={handleCloseModal}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        {/* Modal Header */}
        <div className="cmn_modal_header d-flex justify-content-between align-items-center">
          <p className="cmn_modal_title">Edit User</p>
          <button className="cmn_modal_closer rounded-5" onClick={handleCloseModal}>
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        {/* Modal Body */}
        <div className="mt-4">
          {/* Name Field */}
          <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">Name</p>
            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">
              <input
                type="text"
                name="planName"
                className="rp_singleInput flex-grow-1"
                placeholder="Enter User Name"
                value={formValue.planName || formValue.name || ""}
                onChange={handleChange}
                readOnly
              />
            </div>
            <span className="text-danger">{errors.planName || errors.name}</span>
          </div>

          {/* Wallet Address Field */}
          <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">Wallet Address</p>
            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex align-items-center">
              <input
                type="text"
                name="walletAddress"
                className="rp_singleInput flex-grow-1"
                value={formValue.walletAddress || "-"}
                readOnly
              />
            </div>
            <span className="text-danger">{errors.walletAddress}</span>
          </div>

          {/* Status Dropdown */}
          <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">Statuss</p>
            <div className="rp_input_holder rounded-2 px-0">
              <Select
                options={statusOptions}
                onChange={handleStatusChange}
                value={statusOptions.find((opt) => opt.value === formValue.status) || null}
                isSearchable={false}
                // classNamePrefix="customselect"
                styles={customSelectStyles}
              />
            </div>
            <span className="text-danger">{errors.status}</span>
          </div>

          {/* Submit Button */}
          <button className="orange_small_primary mt-3" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditUsersModal;
